import axios from 'axios'
import store from '@/store'
import router from '@/router'

// Configuration de base - garde exactement vos URLs
let baseUrl = ""
// baseUrl = store.getters['app/baseApiUrl']; //à remettre pour la production
let baseUrlLocal = store.getters['app/baseApiUrlLocal']
// let baseUrlLocal = `http://api.supervizr.net:9001/sgs`
//baseUrl = `https://api.supervizr.net/superadmin`
//baseUrl = `https://api.supervizr.net/sgs`//
//baseUrl = `https://api2.supervizr.net/sgs` //mon serveur de test
//baseUrl = `https://api.supervizr.net/sobraga`
//baseUrl = `https://api.supervizr.net/sgs`
//baseUrl = `https://api.supervizr.net/bakertilly`
//baseUrl = `https://api.supervizr.net/cleanafrica`
//baseUrl = `https://api.supervizr.net/institutflora`
//baseUrl = `https://api.supervizr.net/cnts`
//baseUrl = `https://api.supervizr.net/netis`
//baseUrl = `https://api.supervizr.net/minsantegabon`
//baseUrl = `https://api.supervizr.net/gtech`
//baseUrl = `http://127.0.0.1:9001/sgs`
//baseUrl = `http://127.0.0.1:9001/cleanafrica`
//baseUrl = `http://127.0.0.1:9001/gtech`
//baseUrl = `http://192.168.1.92:9001/sgs`

// baseUrl = `http://localhost:3333/sgs`
baseUrl = store.getters['app/baseApiUrl'];//pour la prod

//à remettre pour la production

//baseUrl = `http://127.0.0.1:9001/gtech`
//baseUrl = `https://api.supervizr.net/sgs`
//baseUrl = `http://127.0.0.1:9001/superadmin`

// Fonction pour obtenir le token ACTUEL depuis le store
const getCurrentToken = () => {
    return store.getters['app/userToken'] || ''
}

// Création de l'instance axios AVEC les headers initialisés
const axiosIns = axios.create({
    baseURL: baseUrl,
    headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        // Initialiser avec le token actuel (vide au début)
        'Authorization': `Bearer ${getCurrentToken()}`,
        'AuthorizationJwt': `${getCurrentToken()}`
    }
})

// Par défaut pour toutes les requêtes
axiosIns.defaults.headers.common['Accept'] = 'application/json'

// Fonction pour mettre à jour TOUS les headers d'axios avec le token actuel
const updateAllAxiosHeaders = () => {
    const currentToken = getCurrentToken()
    
    // Mettre à jour les headers par défaut
    axiosIns.defaults.headers.common['Authorization'] = `Bearer ${currentToken}`
    axiosIns.defaults.headers.common['AuthorizationJwt'] = currentToken
    
    // Mettre à jour les headers de l'instance
    axiosIns.defaults.headers['Authorization'] = `Bearer ${currentToken}`
    axiosIns.defaults.headers['AuthorizationJwt'] = currentToken
    
    console.log('Headers axios mis à jour avec token:', currentToken ? 'OUI' : 'NON')
}

// Intercepteur pour ajouter AuthorizationJwt dans les paramètres de chaque requête
axiosIns.interceptors.request.use(
    config => {
        // RÉCUPÉRER LE TOKEN ACTUEL À CHAQUE REQUÊTE
        const currentToken = getCurrentToken()
        
        // Mettre à jour les headers de cette requête spécifique
        config.headers.Authorization = `Bearer ${currentToken}`
        config.headers.AuthorizationJwt = currentToken
        
        if (config.method === 'get' || config.method === 'delete') {
            // Si la requête est de type GET ou DELETE, ajouter `AuthorizationJwt` aux params
            config.params = {
                ...config.params,
                __tokenJwt__: currentToken
            }
        } else {
            // Pour les autres types de requêtes (POST, PUT, etc.)
            if (config.data instanceof FormData) {
                // Si c'est un FormData, utiliser append()
                config.data.append('__tokenJwt__', currentToken)
            } else if (config.data) {
                // Si c'est un objet normal, ajouter la propriété
                config.data.__tokenJwt__ = currentToken
            } else {
                // Si pas de données, créer un objet
                config.data = { __tokenJwt__: currentToken }
            }
        }
        
        // Log pour debug (optionnel)
        if (process.env.NODE_ENV === 'development') {
            console.log('Requête axios:', {
                url: config.url,
                token: currentToken ? 'PRÉSENT' : 'ABSENT',
                method: config.method
            })
        }
        
        return config
    },
    error => Promise.reject(error)
)

// Intercepteur de réponse
axiosIns.interceptors.response.use(
    response => {
        // Si la réponse est correcte, la retourne simplement
        return response
    },
    error => {
        // Si le statut de la réponse est 401 (Unauthorized)
        if (error.response && error.response.status === 401) {
            console.log('Erreur 401 détectée, déconnexion...')
            
            // Utiliser l'action logout qui nettoie proprement
            store.dispatch('app/logout').then(() => {
                // Mettre à jour les headers après logout
                updateAllAxiosHeaders()
                
                // Rediriger vers login
                if (router.currentRoute.name !== 'login') {
                    router.push('/login')
                }
            }).catch(err => {
                console.error('Erreur lors du logout:', err)
                // Fallback: utiliser la mutation directement
                store.commit('app/SET_USER', null)
                updateAllAxiosHeaders()
                router.push('/login')
            })
        }

        // Retourne l'erreur pour que les appels suivants puissent la gérer
        return Promise.reject(error)
    }
)

// ===== IMPORTANT: SYSTÈME DE SYNCHRONISATION =====

// 1. Écouter les changements du store VUEX
let unsubscribeStore
if (store && store.subscribe) {
    unsubscribeStore = store.subscribe((mutation, state) => {
        // Surveiller toutes les mutations liées à l'utilisateur
        if (mutation.type.startsWith('app/')) {
            const userMutations = ['app/SET_USER', 'app/CLEAR_USER', 'app/SET_USER_TOKEN']
            
            if (userMutations.includes(mutation.type)) {
                console.log('Mutation store détectée:', mutation.type)
                // Mettre à jour les headers d'axios
                updateAllAxiosHeaders()
            }
        }
    })
}

// 2. Écouter les événements globaux (pour synchronisation entre onglets/rafraîchissements)
if (window && window.addEventListener) {
    // Écouter les événements de changement d'utilisateur
    window.addEventListener('user-token-changed', (event) => {
        console.log('Événement global user-token-changed reçu')
        updateAllAxiosHeaders()
    })
    
    // Écouter les événements de déconnexion
    window.addEventListener('user-logged-out', () => {
        console.log('Événement global user-logged-out reçu')
        updateAllAxiosHeaders()
    })
}

// 3. Initialiser les headers au démarrage
updateAllAxiosHeaders()

// 4. Exposer une fonction pour forcer la mise à jour (utile pour debug)
export const refreshAxiosToken = () => {
    console.log('Forçage de la mise à jour du token axios')
    updateAllAxiosHeaders()
}

// 5. Pour nettoyage si nécessaire (dans main.js ou App.vue)
export const cleanupAxiosListeners = () => {
    if (unsubscribeStore) {
        unsubscribeStore()
    }
}

console.log('Configuration axios initialisée. Token initial:', getCurrentToken() ? 'PRÉSENT' : 'ABSENT')
console.log('URL de base:', baseUrl)
console.log('URL locale:', baseUrlLocal)

export default axiosIns